import useFeedback from "../utils/use_feedback";
import {useCommunities} from "../api/communities";
import Image from './image';

// generated by https://png-pixel.com/
export const placeholderImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPc/x8AAoMBwP8UKJsAAAAASUVORK5CYII=';

const CommunityLogo = ({name}) => {
    const loading = useFeedback();
    const community = useCommunities(loading.channel, [name])[0];
    const logoUrl = community?.icon ? `https://img.scored.co/community/${name?.toLowerCase()}-icon-192x192.png?v=${community.icon_id}` : placeholderImage;
    return (
        <Image
            src={logoUrl || placeholderImage}
            fallbackSrc={placeholderImage}
        />
    );
};

export default CommunityLogo;
